module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAsCAMAAAC9vAPBAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRFz+LZ29zc6Ojp2evj6vLtytfQzd3V9fb1+/z8yNLN4OHh7/Xx0Obc0dHR////3u7pU0SdawAAANNJREFUeNqM0tuuhCAMBdBCUW6F/v/fHqAeh0snmf2iWWm2RYV6JDsPz63nFkQkImT3aED+hKooz8ggDY6XXNLgl1GOQZnFKL3rKKWhWwHZrmFFJt91Q1FmTelHrd80qOoPhT4Lu969N2rqL3VWb0BVE2lqorJZTYWUEwdVjxeBuWk+lnBNHWvKZ9qJUVNWZ/N9PXl3wdZQ/jNrehWm/9clYyX3/lePxHcbN2mRr4KrmtI6CCLArG2bG8Zz86TVlhKH2lmDGbRpZz9uFq3ByvVPgAEA/4ov0ADFhboAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/MS.png
// module id = +NNO
// module chunks = 1